import { useMemo } from 'react';

import { SENTIMENT_NAMES } from 'src/components/dashboard/charts/ComparisonTableChart/helper';
import type { StackedNumbersList } from 'src/components/followUp/common/types';

export const useComparisonExportData = (data: StackedNumbersList | undefined) =>
  useMemo(() => {
    if (!data) {
      return { totalObjects: 0, results: [] };
    }

    const transformedResults = data.results.map((result) => {
      const filteredStacks = result.stacks.filter((stack) => {
        let sentiment: keyof typeof SENTIMENT_NAMES;
        for (sentiment in SENTIMENT_NAMES) {
          const prefix = `[${sentiment}]`;
          if (stack.stackLabel.startsWith(prefix)) {
            // Keep only stacks with the '[positive]' prefix or no prefix
            return sentiment === 'positive';
          }
        }
        return true; // Keep stacks with no sentiment prefix
      });

      const processedStacks = filteredStacks.map((stack) => {
        let newStackLabel = stack.stackLabel;
        let sentiment: keyof typeof SENTIMENT_NAMES;
        for (sentiment in SENTIMENT_NAMES) {
          const prefix = `[${sentiment}]`;
          if (newStackLabel.startsWith(prefix)) {
            newStackLabel = newStackLabel.substring(prefix.length).trim();
            break;
          }
        }
        return { ...stack, stackLabel: newStackLabel };
      });

      return { ...result, stacks: processedStacks };
    });

    // Typehint the return value as StackedNumbersList
    return { ...data, results: transformedResults } as StackedNumbersList;
  }, [data]);
